import "./App.css";

import Homepage from "./Pages/Homepage";

function App() {
  return (
    <div className="App">
      <div>
        <Homepage />
      </div>
    </div>
  );
}

export default App;
